import { render, staticRenderFns } from "./errorTestA.vue?vue&type=template&id=37ba940a"
import script from "./errorTestA.vue?vue&type=script&lang=js"
export * from "./errorTestA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports